export class PDREContact {
    Nom: string;
    Prenom: string;
    Role: string;
    Courriel: string;

    static mapFromJSON(json) {
        const m = new PDREContact();

        m.Nom = json['nom'];
        m.Prenom = json['prenom'];
        m.Role = json['role'];
        m.Courriel = json['courriel'];

        return m;
    }
}